import React, { useState, useRef } from 'react'
import { useDeleteArticleMutation } from '../../../../../generated/graphql'
import MelddButton from '../../../../../@ui/buttons/meldd.button'
import { useTranslation } from 'react-i18next'
import {
  ConfirmDialogue,
  ConfirmDialogueRef,
} from '../../../../../@ui/containers/modals/confirm.dialogue'
import { useNavigation } from '@react-navigation/native'
import { AppNavigation } from '../../../../../navigation/types'

interface DeleteArticleButtonProps {
  articleId: string
  onDeleted?: () => void
  isDisabled?: boolean
  style?: any
}

const DeleteArticleButton: React.FC<DeleteArticleButtonProps> = ({
  articleId,
  onDeleted,
  isDisabled,
  style,
}) => {
  const { t } = useTranslation('articles')
  const confirmDialogRef = useRef<ConfirmDialogueRef>(null)
  const navigation = useNavigation<AppNavigation>()
  const [doDeleteArticle, { loading }] = useDeleteArticleMutation({
    refetchQueries: [
      {
        query: require('../../../../../generated/graphql').ArticleDocument,
        variables: { id: articleId },
      },
      // Optionally add more queries to refetch if needed
    ],
    awaitRefetchQueries: true,
  })

  const handleDelete = async () => {
    try {
      // After delete as we may be on the Perspective screen it will
      // throw and exception trying to read the article
      // so we need to navigate to the ClusterList screen
      await doDeleteArticle({ variables: { id: articleId } })
    } finally {
      onDeleted?.()
      confirmDialogRef.current?.close()
      navigation.navigate('ClusterList', {})
    }
  }

  const confirmDelete = () => {
    confirmDialogRef.current?.open()
  }

  return (
    <>
      <MelddButton
        onPress={confirmDelete}
        color="#e57373"
        textColor="white"
        title={t('delete')}
        fontSize={15}
        isDisabled={isDisabled || loading}
        isLoading={loading}
        style={style}
      />
      <ConfirmDialogue
        ref={confirmDialogRef}
        label={t('delete-perspective-confirm-message')}
        acceptLabel={t('delete')}
        cancelLabel={t('cancel')}
        onContinue={handleDelete}
      />
    </>
  )
}

export default DeleteArticleButton
